export default {
  exportHeader: 'Exportovať hlavičku',
};
